import { render, staticRenderFns } from "./ParametersModal.vue?vue&type=template&id=c488435a&scoped=true&"
import script from "./ParametersModal.vue?vue&type=script&lang=js&"
export * from "./ParametersModal.vue?vue&type=script&lang=js&"
import style0 from "./ParametersModal.vue?vue&type=style&index=0&id=c488435a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c488435a",
  null
  
)

export default component.exports